export const inputStyles = {
  color: "white",
  fontWeight: "medium",
  textIndent: "0.875rem",
};

export const formStyles = {
  form: {
    textAlign: "center",
    minWidth: {
      laptop: "23.75rem",
    },
    width: {
      laptop: "23.75rem",
    },
  },
  container: {
    mb: {
      mobile: "3rem",
      tablet: "1.5rem",
    },
  },
  textField: {
    height: "3.875rem",
    color: "white.main",
  },
  buttonWrapper: {
    textAlign: {
      tablet: "right",
    },
  },
};
